import { render, staticRenderFns } from "./AdminLocations.vue?vue&type=template&id=7c50f9c7&scoped=true&"
import script from "./AdminLocations.vue?vue&type=script&lang=js&"
export * from "./AdminLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c50f9c7",
  null
  
)

export default component.exports